export default __webpack_public_path__ + "img/dahla_alumni.acb3b7ba.png";